import {create} from 'zustand';

const useDonorsModal = create((set) => ({
  isOpen: false,
  open: () => set({isOpen: true}),
  close: () => set({isOpen: false}),
}));


export default useDonorsModal;